import { CategoriesApiRemoteService } from '../../Services/api/categories/categories-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyCategoriesUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly CategoriesApi: CategoriesApiRemoteService) {}
    

  public async handle (
    categoryId: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CategoriesApi.destroy(categoryId)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
